import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-audit-status-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span *ngIf="!deleted"
          class="inline-block text-xs px-2 py-0.5 rounded"
          [ngClass]="{
            'badge-active':              status === 'PROGRESS',
            'badge-success':             status === 'FINISH',
            'bg-filter-inactive text-muted': status === 'ARCHIVED' || status === '0'
          }">
      {{ ('COMMON.AUDIT_STATUS_' + status) | translate }}
    </span>
    <span *ngIf="deleted"
          class="inline-block text-xs px-2 py-0.5 rounded badge-error">
      {{ 'COMMON.AUDIT_STATUS_DELETED' | translate }}
    </span>
  `,
})
export class AuditStatusBadgeComponent {
  @Input() status: string | null | undefined;
  @Input() deleted: boolean | null | undefined = false;
}
